import { gatewayPhone } from "src/gateways/gatewayPhone";
import { CallFlowConfig } from "@components/virtual-receptionist/sms/types/update-company-config";
import { VoiceMessageSlot } from "../constants/voice-message-slots";

export const uploadVoiceMessageRecording = async (
    companyId: number,
    slotKey: VoiceMessageSlot,
    audio: File,
): Promise<CallFlowConfig> => {
    const formData = new FormData();
    formData.append("audio", audio, audio.name);

    const { data } = await gatewayPhone.post(
        `company-call-config/${companyId}/voice-messages/${slotKey}/recording`,
        formData,
    );

    return data;
};
